export default __webpack_public_path__ + "static/media/Button.aa1cd57a.svg";